import Nav from "@/components/Nav";

export default function Privacy() {
  return (
    <div className="min-h-screen">
      <Nav />
      <main className="mx-auto max-w-2xl px-5 py-16 sm:px-8" data-testid="privacy-page">
        <p className="overline">Privacy</p>
        <h1 className="mt-2 font-serif text-4xl tracking-tight sm:text-5xl">Your photos are yours.</h1>
        <div className="mt-8 space-y-5 leading-relaxed text-[#5E5868]">
          <p><strong className="text-[#26232E]">Retention.</strong> Photos you upload are kept only while you build your book. Once your order is delivered, all uploaded photos for that book are automatically deleted after 30 days. Draft books you delete are removed immediately.</p>
          <p><strong className="text-[#26232E]">AI processing.</strong> To curate and caption your book, small preview copies of your photos are sent to our AI provider. They're used only to arrange your book and not to train models.</p>
          <p><strong className="text-[#26232E]">Printing.</strong> Your print-ready files are shared only with our print partner to produce and ship your book — primarily an India-based printer.</p>
          <p><strong className="text-[#26232E]">Delivery.</strong> We aim to deliver within about 2 weeks. That's a target, not a guarantee.</p>
        </div>
      </main>
    </div>
  );
}
